import React, { FC, useEffect, useState } from 'react';
import { UseControllerProps, useController } from 'react-hook-form';
import Icon from '@components/common/assets';
import NHISCareerModal from './nhisCareerModal';
import WorkingPreference from './workingPreference/WorkingPreference';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ExperienceProps extends UseControllerProps {
  setIsExperienceFilled: (isExperienceFilled: boolean) => void;
  setExperienceClicked: (experienceClicked: boolean) => void;
}

const Experience: FC<ExperienceProps> = ({ setIsExperienceFilled, setExperienceClicked, ...props }) => {
  const [isNhisModalVisible, setIsNhisModalVisible] = useState(false);
  const [selectedButton, setSelectedButton] = useState<string | null>(null);
  const [isWorkingPreferenceVisible, setIsWorkingPreferenceVisible] = useState(false);
  const [isNhisCompleted, setIsNhisCompleted] = useState(false);
  const [isInitial, setIsInitial] = useState<boolean>(true);
  const { field } = useController(props);
  useEffect(() => {
    if (field.value && isInitial) {
      setSelectedButton(field.value);
      if (field.value === 'nhis') {
        setIsNhisCompleted(true);
        setIsWorkingPreferenceVisible(true);
        setIsExperienceFilled(true);
      } else if (field.value === 'newbie') {
        setIsWorkingPreferenceVisible(true);
        setIsExperienceFilled(true);
      }
      setIsInitial(false);
    }
  }, [field.value, isInitial, setIsExperienceFilled]);

  const onCloseNhisModal = () => {
    setIsNhisModalVisible(false);
    if (!isNhisCompleted) {
      setSelectedButton(null);
    }
  };

  const handleNhisClick = () => {
    setSelectedButton('nhis');
    setIsNhisModalVisible(true);
    setIsWorkingPreferenceVisible(false);
    setIsExperienceFilled(false);
    setExperienceClicked(false);
  };

  const handleNewbieClick = () => {
    setSelectedButton('newbie');
    field.onChange('newbie');

    setIsNhisModalVisible(false);
    setIsWorkingPreferenceVisible(true);
    setIsExperienceFilled(true);
    setExperienceClicked(true);
  };
  return (
    <div className={cx('wrap')}>
      <div className={cx('questionTitle')}>경력을 알려주세요.</div>
      <div className={cx('experienceWrap')}>
        <button
          type="button"
          className={cx('btnBasic', { selected: selectedButton === 'nhis' })}
          onClick={handleNhisClick}
          disabled={isNhisCompleted}
          name="nhis"
        >
          <span className={cx('nhisArea')}>
            1분만에 내 모든 경력을 불러올래요.
            {isNhisCompleted && <Icon name={'verifiedLightFilled'} fill={Colors.C_GREEN_150} width={24} height={24} />}
          </span>
          <span className={cx('subText')}>경력을 입력한 회원은 6.7배 더 많은 매칭 제안을 받았어요.</span>
        </button>
        <button
          type="button"
          className={cx('btnBasic', { selected: selectedButton === 'newbie' })}
          onClick={handleNewbieClick}
          disabled={isNhisCompleted}
          name="newbie"
        >
          아직 신입이에요! 잡다를 통해 취업준비 하고 싶어요.
        </button>
      </div>

      <div className={cx('subTitle')}>내 프로필에서 경력을 수정할 수 있습니다.</div>

      {/* 경력 불러오기 */}
      <NHISCareerModal
        visible={isNhisModalVisible}
        onClose={onCloseNhisModal}
        onComplete={() => {
          setSelectedButton('nhis');
          field.onChange('nhis');
          setIsNhisCompleted(true);
          setIsWorkingPreferenceVisible(true);
          setIsExperienceFilled(true);
          setExperienceClicked(true);
        }}
      />
      {/* 근무 조건 */}
      {isWorkingPreferenceVisible && (
        <div className={cx('freeInputArea')}>
          <div className={cx('questionTitle')}>희망하는 근무 조건을 자유롭게 입력해 주세요.</div>
          <WorkingPreference name={'workingPreference'} visible={true} />
        </div>
      )}
    </div>
  );
};

export default Experience;
